var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sc-analytics-summary columns" },
    [
      _vm.loading ? _c("sc-page-loading") : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.summaries, function(summary, index) {
        return _c("div", { key: summary.title, staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "box sc-analytics-summary__box" },
            [
              _c(
                "sc-tooltip",
                {
                  staticClass: "sc-analytics-summary__box__help",
                  attrs: {
                    label: summary.title,
                    position: _vm.getTooltipPosition(index),
                    type: "is-white"
                  }
                },
                [_c("sc-icon", { attrs: { icon: "question-circle" } })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sc-analytics-summary__box__title" }, [
                _vm._v("\n        " + _vm._s(summary.title) + "\n      ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sc-analytics-summary__box__value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getFormattedValue(summary.value)) +
                    "\n      "
                )
              ])
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7500ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7500ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-summary/ScAnalyticsSummary.vue
// module id = null
// module chunks = 